export const AUTH = "auth";
export const PROFILE = "profile";
export const FEATURES = "features"
